export function useTawk() {
  function getTawkAPI() {
    if (!import.meta.client)
      return null
    return (window as any).Tawk_API ?? null
  }

  function isLoaded(): boolean {
    return typeof getTawkAPI()?.maximize === 'function'
  }

  function openChat() {
    const api = getTawkAPI()
    if (api?.maximize) {
      api.maximize()
    }
  }

  function closeChat() {
    const api = getTawkAPI()
    if (api?.minimize) {
      api.minimize()
    }
  }

  function onChatMinimized(callback: () => void) {
    const api = getTawkAPI()
    if (api) {
      api.onChatMinimized = callback
    }
  }

  function clearOnChatMinimized() {
    const api = getTawkAPI()
    if (api) {
      api.onChatMinimized = undefined
    }
  }

  return {
    isLoaded,
    openChat,
    closeChat,
    onChatMinimized,
    clearOnChatMinimized,
  }
}
